import React, { useEffect, useState } from "react";
import ExpertModalCart from "./ExpertModalCart";

const ExpertModal = ({ editData, setExpertModalOpen }) => {
  const [expertItem, setExpertItem] = useState({});

  useEffect(() => {
    if (localStorage?.getItem("expertItem")) {
      setExpertItem(JSON.parse(localStorage.getItem("expertItem")));
    } else {
    }
  }, []);

  return (
    <div
      className={
        "absolute z-50 w-full h-full top-0 left-0 bg-[#000]/30 rounded-[12px] p-4 flex justify-center items-center"
      }
    >
      <div className={"bg-white shadow w-80 h-fit p-2 rounded-[16px]"}>
        <span className={"inline-block mb-2"}>انتخاب کارشناس</span>
        <ul className={"flex flex-col gap-2"}>
          {editData?.expert?.map((item) => (
            <ExpertModalCart
              key={item.id}
              item={item}
              expertId={expertItem?.id}
              setExpertItem={setExpertItem}
            />
          ))}
        </ul>
        <div className={"text-left"}>
          <button
            disabled={!expertItem?.id}
            className={`${expertItem?.id ? "bg-[#7cb997]" : "bg-stone-400"}  text-white w-20 h-8 rounded-[4px]`}
            onClick={() => {
              setExpertModalOpen(false);
              localStorage.setItem("expertId", String(expertItem?.id));
              localStorage.setItem("expertItem", JSON.stringify(expertItem));
            }}
          >
            ثبت
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpertModal;
